import { render, staticRenderFns } from "./FeedManagerHeader.vue?vue&type=template&id=735447fa&scoped=true&"
import script from "./FeedManagerHeader.vue?vue&type=script&lang=js&"
export * from "./FeedManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerHeader.vue?vue&type=style&index=0&id=735447fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735447fa",
  null
  
)

export default component.exports